module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Profit & Loss")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total Profit: " + _vm._s(_vm.formatCurrency(_vm.totalProfit)) + " | Total Records: " + _vm._s(_vm.totalRecords))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by job no, billing party...",
      "size": "sm"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [10, 25, 50, 100],
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-info",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.refreshData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n            Refresh\n          ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    staticClass: "mb-0",
    attrs: {
      "items": _vm.profitLossData,
      "fields": _vm.fields,
      "busy": _vm.isLoading,
      "striped": "",
      "bordered": "",
      "hover": "",
      "small": "",
      "show-empty": "",
      "empty-text": "No profit & loss data found"
    },
    scopedSlots: _vm._u([{
      key: "pl_job_no",
      fn: function(data) {
        return [_c('code', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "pl_billing_party",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "pl_expenses",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "pl_incomes",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "pl_profit",
      fn: function(data) {
        return [_c('strong', {
          class: data.value >= 0 ? 'text-success' : 'text-danger'
        }, [_vm._v("\n            " + _vm._s(_vm.formatCurrency(data.value)) + "\n          ")])]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('b-button', {
          staticClass: "toggle-btn",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.toggleDetails(data.item)
            }
          }
        }, [_c('i', {
          class: data.item._showDetails ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
        })])]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('div', {
          staticClass: "row-details"
        }, [(row.item.jobDetails) ? _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-success"
        }, [_c('div', {
          staticClass: "card-header bg-success text-white"
        }, [_c('i', {
          staticClass: "fa fa-briefcase"
        }), _vm._v(" Job Details\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row.item.jobDetails.JobNo) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(_vm.formatDate(row.item.jobDetails.JobDate)) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job Type:")]), _vm._v(" " + _vm._s(row.item.jobDetails.JobType) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(row.item.jobDetails.JobTransportType) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s(row.item.jobDetails.ClientName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Shipping Line:")]), _vm._v(" " + _vm._s(row.item.jobDetails.SlineName) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(row.item.jobDetails.RaisedBy) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row.item.jobDetails.RaisedFrom) + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-2"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("POL → POD:")]), _vm._v(" " + _vm._s(row.item.jobDetails.POL) + " → " + _vm._s(row.item.jobDetails.POD) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Container Type:")]), _vm._v(" " + _vm._s(row.item.jobDetails.JobContainerType) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Enquiry:")]), _vm._v(" " + _vm._s(row.item.jobDetails.EnqNo) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("SOB:")]), _vm._v(" " + _vm._s(row.item.jobDetails.SOB) + "\n                      ")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "row mb-3"
        }, [_c('div', {
          staticClass: "col-12"
        }, [_c('div', {
          staticClass: "card border-primary"
        }, [_c('div', {
          staticClass: "card-header bg-primary text-white"
        }, [_c('i', {
          staticClass: "fa fa-chart-line"
        }), _vm._v(" P&L Summary\n                  ")]), _vm._v(" "), _c('div', {
          staticClass: "card-body"
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("P&L ID:")]), _vm._v(" " + _vm._s(row.item.pl_id) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row.item.pl_job_no) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Billing Party:")]), _vm._v(" " + _vm._s(row.item.pl_billing_party) + "\n                      ")]), _vm._v(" "), _c('div', {
          staticClass: "col-md-3"
        }, [_c('strong', [_vm._v("Employee:")]), _vm._v(" " + _vm._s(row.item.pl_cu_relation.employeeName || 'N/A') + "\n                      ")])]), _vm._v(" "), _c('div', {
          staticClass: "row mt-3"
        }, [_c('div', {
          staticClass: "col-md-4"
        }, [_c('div', {
          staticClass: "text-center"
        }, [_c('h5', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(_vm.formatCurrency(row.item.pl_expenses)))]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Total Expenses")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-4"
        }, [_c('div', {
          staticClass: "text-center"
        }, [_c('h5', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(_vm.formatCurrency(row.item.pl_incomes)))]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Total Income")])])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-4"
        }, [_c('div', {
          staticClass: "text-center"
        }, [_c('h5', {
          class: row.item.pl_profit >= 0 ? 'text-success' : 'text-danger'
        }, [_vm._v("\n                            " + _vm._s(_vm.formatCurrency(row.item.pl_profit)) + "\n                          ")]), _vm._v(" "), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v("Net Profit/Loss")])])])])])])])])])]
      }
    }])
  }, [_c('template', {
    slot: "table-busy"
  }, [_c('div', {
    staticClass: "text-center text-danger my-2"
  }, [_c('b-spinner', {
    staticClass: "align-middle",
    attrs: {
      "small": ""
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v("Loading...")])], 1)])], 2), _vm._v(" "), (_vm.totalItems > _vm.perPage) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalItems
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-2 d-flex justify-content-between align-items-center"
  }, [_c('div', [_c('b-form-select', {
    staticClass: "w-auto",
    attrs: {
      "options": _vm.pagination.pageOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.updatePagination
    },
    model: {
      value: (_vm.pagination.perPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "perPage", $$v)
      },
      expression: "pagination.perPage"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-muted"
  }, [_vm._v("per page")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n          Total Records: " + _vm._s(_vm.totalItems) + " | Total Profit: " + _vm._s(_vm.formatCurrency(_vm.totalProfit)) + "\n        ")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a34bb7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard/ProfitLossSection.vue
// module id = 2403
// module chunks = 0